import settings from '@/settings'

let sendmail = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

let verificarPessoa = (email, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/poremail/?email=${email}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let verificarCPF = (headers, cpf) => {
  return fetch(`${settings.apetrusApi}/pessoas/verificarcpf/?cpf=${cpf}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let detalharPorAdmin = (data, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/poradministrador/?${data.filter}=${data.value}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserir = (body, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/cadastrarporadministrador/`, {
    method: 'post',
    body: JSON.stringify(body),
    mode: 'cors',
    headers: headers
  })
}

let contact = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/api/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

let influenciador = (data, headers) => {
  // Responsavel por cadastrar, Deletar, Atualizar
  return fetch(`${settings.apetrusApi}/clientes/influenciador/`, {
    method: data.method,
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let pegarInfluenciador = (data, headers) => {
  const keys = Object.keys(data)
  let url = `${settings.apetrusApi}/clientes/influenciador/`
  for (let i = 0; i < keys.length; i++) {
    url = data[keys[i]] !== null && data[keys[i]] !== undefined && data[keys[i]] !== '' ? `${url}${url[url.length - 1] !== '/' ? '&' : '?'}${keys[i]}=${data[keys[i]]}` : `${url}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let solicitacoesRetirada = (headers) => {
  return fetch(`${settings.apetrusApi}/clientes/solicitacaoretirada/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let marcarComoPago = (headers, data) => {
  return fetch(`${settings.apetrusApi}/clientes/solicitacaoretirada/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let carteiraVirtual = (headers, data) => {
  let url
  if (data.id_pessoa) {
    url = `${settings.apetrusApi}/carteiravirtual/admin/?id_pessoa=${data.id_pessoa}`
  } else if (data.cnpj_posto) {
    url = `${settings.apetrusApi}/carteiravirtual/admin/?cnpj_posto=${data.cnpj_posto}`
  } else if (data.cnpj_empresa) {
    url = `${settings.apetrusApi}/carteiravirtual/admin/?cnpj_empresa=${data.cnpj_empresa}`
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const clientesFiltrados = (headers, filtros) => {
  let url = `${settings.apetrusApi}/clientes/filtrarclientes/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  sendmail,
  inserir,
  contact,
  verificarPessoa,
  verificarCPF,
  detalharPorAdmin,
  influenciador,
  pegarInfluenciador,
  solicitacoesRetirada,
  marcarComoPago,
  carteiraVirtual,
  clientesFiltrados
}
